import { render, staticRenderFns } from "./MEM925M01.vue?vue&type=template&id=2ba67a25&"
import script from "./MEM925M01.vue?vue&type=script&lang=js&"
export * from "./MEM925M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports